/* Enova cart drawer. Cosmetic timer + progress bar; gift auto-add; opt-in add-ons. */
(() => {
  const R = document.querySelector('[data-ec]');
  if (!R) return;
  const D = R.dataset, OP = +D.op, DP = +D.dp, GIFT = +D.gift, GIFT_CMP = +D.giftCmp, GA = +D.giftAt, SA = +D.shipAt;
  const ADDONS = new Set([OP, DP, GIFT]);
  const $ = s => R.querySelector(s);
  const money = c => '$' + (c / 100).toFixed(2);
  const esc = s => String(s).replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const api = (u, body) => fetch(u, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
    .then(r => r.json().then(j => (r.ok ? j : Promise.reject(j))));
  const getCart = () => api('/cart.js');
  const cmpCache = {};
  const compareFor = async item => {
    if (!(item.handle in cmpCache)) {
      cmpCache[item.handle] = api('/products/' + item.handle + '.js').then(p => Object.fromEntries(p.variants.map(v => [v.id, v.compare_at_price || 0]))).catch(() => ({}));
    }
    const m = await cmpCache[item.handle];
    return m[item.variant_id] || 0;
  };
  const base = c => c.items.filter(i => !ADDONS.has(i.variant_id));
  const baseSub = c => base(c).reduce((s, i) => s + i.final_line_price, 0);

  // Keep the gift + add-ons consistent with the cart.
  async function reconcile(c, depth = 0) {
    if (depth > 2) return c;
    const b = base(c), sub = baseSub(c), gift = c.items.find(i => i.variant_id === GIFT), upd = {};
    if (b.length && sub >= GA) {
      if (!gift) { await api('/cart/add.js', { items: [{ id: GIFT, quantity: 1 }] }); return reconcile(await getCart(), depth + 1); }
      if (gift.quantity !== 1) upd[gift.key] = 1;
    } else if (gift) upd[gift.key] = 0;
    c.items.filter(i => i.variant_id === OP || i.variant_id === DP).forEach(i => { if (!b.length) upd[i.key] = 0; else if (i.quantity > 1) upd[i.key] = 1; });
    if (Object.keys(upd).length) return reconcile(await api('/cart/update.js', { updates: upd }), depth + 1);
    return c;
  }

  // Cosmetic countdown: restarts at 9:57 every time the cart opens, loops at zero. Changes nothing.
  let tmr = null, left = 0;
  const tick = () => { const m = Math.floor(left / 60), s = left % 60; $('[data-ec-timer]').textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0'); left = left > 0 ? left - 1 : 600; };
  const startTimer = () => { clearInterval(tmr); left = 597; tick(); tmr = setInterval(tick, 1000); };

  function progress(sub) {
    const fill = sub >= SA ? 100 : sub < GA ? (sub / GA) * 30 : 30 + ((sub - GA) / Math.max(1, SA - GA)) * 45;
    $('[data-ec-fill]').style.width = Math.max(0, Math.min(100, fill)) + '%';
    R.querySelector('[data-ec-mk="gift"]').classList.toggle('on', sub >= GA);
    R.querySelector('[data-ec-mk="ship"]').classList.toggle('on', sub >= SA);
    $('[data-ec-msg]').innerHTML = sub < GA ? `Add <b>${money(GA - sub)}</b> to get a <b>Free Mystery Gift</b>`
      : sub < SA ? `Add <b>${money(SA - sub)}</b> to get <b>Free Shipping</b>`
      : `You unlocked <b>Free Gift</b> and <b>Free Shipping</b>`;
  }

  async function render(c) {
    const b = base(c), sub = baseSub(c), gift = c.items.find(i => i.variant_id === GIFT);
    $('[data-ec-count]').textContent = b.length ? '(' + b.reduce((s, i) => s + i.quantity, 0) + ')' : '';
    document.querySelectorAll('[data-count]').forEach(e => { e.textContent = b.reduce((s, i) => s + i.quantity, 0); });
    progress(sub);
    $('[data-ec-addons]').hidden = !b.length;
    $('[data-ec-foot]').hidden = !b.length;
    R.querySelector('[data-ec-addon="op"]').checked = c.items.some(i => i.variant_id === OP);
    R.querySelector('[data-ec-addon="dp"]').checked = c.items.some(i => i.variant_id === DP);
    if (!b.length) { $('[data-ec-items]').innerHTML = '<p class="ec-empty">Your cart is empty.</p><button type="button" class="ec-co ec-keep" data-ec-close>Keep shopping</button>'; return; }
    let savings = 0;
    const rows = await Promise.all(b.map(async i => {
      const cmp = await compareFor(i), was = cmp > i.final_price ? cmp * i.quantity : 0;
      if (was) savings += was - i.final_line_price;
      const img = i.image ? `<img src="${esc(i.image)}&width=160" alt="" width="72" height="72">` : '';
      const variant = i.product_has_only_default_variant || /^Buy 1$/.test(i.variant_title || '') ? '' : `<small>${esc(i.variant_title || '')}</small>`;
      return `<article class="ec-line">${img}<div class="ec-li"><div class="ec-lt"><b>${esc(i.product_title)}</b>${variant}</div>
        <div class="ec-lr"><div class="ec-qty"><button type="button" data-q="${esc(i.key)}" data-n="${i.quantity - 1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button type="button" data-q="${esc(i.key)}" data-n="${i.quantity + 1}" aria-label="Increase">+</button></div>
        <span class="ec-pr">${was ? `<s>${money(was)}</s>` : ''}<b>${money(i.final_line_price)}</b></span></div></div>
        <button type="button" class="ec-rm" data-q="${esc(i.key)}" data-n="0" aria-label="Remove">×</button></article>`;
    }));
    if (gift) {
      savings += GIFT_CMP;
      const img = gift.image ? `<img src="${esc(gift.image)}&width=160" alt="" width="72" height="72">` : '<span class="ec-gift-ic">🎁</span>';
      rows.push(`<article class="ec-line ec-gift">${img}<div class="ec-li"><div class="ec-lt"><b>Free Mystery Gift</b><small>Unlocked with your order</small></div>
        <div class="ec-lr"><span></span><span class="ec-pr"><s>${money(GIFT_CMP)}</s><b class="ec-free">FREE</b></span></div></div></article>`);
    }
    $('[data-ec-items]').innerHTML = rows.join('');
    savings += c.total_discount || 0;
    R.querySelector('.ec-sav').hidden = savings <= 0;
    $('[data-ec-savings]').textContent = '−' + money(savings);
    $('[data-ec-sub]').textContent = money(c.total_price);
    $('[data-ec-total]').textContent = money(c.total_price);
  }

  let busy = false;
  async function run(fn) {
    if (busy) return; busy = true; R.classList.add('is-busy');
    try { await render(await reconcile(await fn())); } catch (e) { console.warn('cart', e); try { await render(await getCart()); } catch (_) {} }
    finally { busy = false; R.classList.remove('is-busy'); }
  }

  const open = () => { R.hidden = false; requestAnimationFrame(() => R.classList.add('is-open')); document.documentElement.classList.add('ec-lock'); startTimer(); };
  const close = () => { R.classList.remove('is-open'); document.documentElement.classList.remove('ec-lock'); clearInterval(tmr); setTimeout(() => { R.hidden = true; }, 260); };

  async function add(id, qty = 1) {
    open();
    $('[data-ec-items]').innerHTML = '<p class="ec-empty">Adding to your cart…</p>';
    await run(async () => { await api('/cart/add.js', { items: [{ id: +id, quantity: qty }] }); return getCart(); });
  }

  R.addEventListener('click', e => {
    if (e.target.closest('[data-ec-close]')) { close(); return; }
    const q = e.target.closest('[data-q]');
    if (q) run(() => api('/cart/change.js', { id: q.dataset.q, quantity: Math.max(0, +q.dataset.n) }));
  });
  R.addEventListener('change', e => {
    const box = e.target.closest('[data-ec-addon]'); if (!box) return;
    const id = box.dataset.ecAddon === 'op' ? OP : DP;
    run(async () => {
      if (box.checked) { await api('/cart/add.js', { items: [{ id, quantity: 1 }] }); return getCart(); }
      const c = await getCart(), line = c.items.find(i => i.variant_id === id);
      return line ? api('/cart/change.js', { id: line.key, quantity: 0 }) : c;
    });
  });
  addEventListener('keydown', e => { if (e.key === 'Escape' && !R.hidden) close(); });

  // Bag icons open the drawer.
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-ec-open], .pd-bagbtn');
    if (a) { e.preventDefault(); open(); run(getCart); }
  });
  // Product forms add via AJAX and open the drawer (no straight-to-checkout).
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-ec-atc]'); if (!f) return;
    e.preventDefault();
    const id = f.querySelector('[name="id"]').value;
    add(id).catch(() => f.submit());
  });
  window.EnovaCart = { open: () => { open(); run(getCart); }, add };
  run(getCart);
})();
